import React from "react";
import ReactDOM from "react-dom/client";
import App from "./views/App";
import { Provider } from "react-redux";
import { createBrowserHistory } from "history";
import rootStore from "./stores/rootStore";
import { SnackbarProvider } from "notistack";
import "./index.css";

const initialState = {};
const store = rootStore(initialState);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <SnackbarProvider maxSnack={30}>
    <Provider store={store}>
      <App />
    </Provider>
  </SnackbarProvider>
);
